module.exports = __webpack_public_path__ + "media/andenes/minidock_poweramp-f92cf9fb.webp";